import { render } from "./AutoSaleForm.vue?vue&type=template&id=2cf33746&scoped=true"
import script from "./AutoSaleForm.vue?vue&type=script&lang=js"
export * from "./AutoSaleForm.vue?vue&type=script&lang=js"

import "./AutoSaleForm.vue?vue&type=style&index=0&id=2cf33746&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cf33746"]])

export default __exports__